import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-all-invoice',
  templateUrl: './all-invoice.component.html',
  styleUrls: ['./all-invoice.component.css']
})
export class AllInvoiceComponent implements OnInit {

  private dp = [];
  displayedColumns = ['invoice_no', 'invoice_date', 'tax_name', 'tax', 'discount', 'final_total', 'payment_method'];
  dataSource = new MatTableDataSource(this.dp);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'title': 'قائمة فواتير' };

  type = '';
  no = '';
  name = '';
  title = 'قائمة فواتير';
  back_link = '';

  Invoice_List; Cust_Sale_Invoice; Supp_Purc_Invoice;
  Cash; Bank; Visa; credit; Name; Number;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private route: ActivatedRoute,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Invoice_List').subscribe((res: string) => {
      this.Invoice_List = res;
    });
    this.title = this.Invoice_List;
    this.model['title'] = this.Invoice_List;

    translate.get('Cust_Sale_Invoice').subscribe((res: string) => {
      this.Cust_Sale_Invoice = res;
    });

    translate.get('Supp_Purc_Invoice').subscribe((res: string) => {
      this.Supp_Purc_Invoice = res;
    });

    translate.get('Cash').subscribe((res: string) => {
      this.Cash = res;
    });

    translate.get('Bank').subscribe((res: string) => {
      this.Bank = res;
    });

    translate.get('Visa').subscribe((res: string) => {
      this.Visa = res;
    });

    translate.get('Debit').subscribe((res: string) => {
      this.credit = res;
    });

    translate.get('Name').subscribe((res: string) => {
      this.Name = res;
    });

    translate.get('Number').subscribe((res: string) => {
      this.Number = res;
    });

  }

  ngOnInit() {
    //this.model['from_date'] = undefined;

    this.route.params.subscribe(params => {
      this.type = params['type'];
      this.no = params['no'];

      ////////////////////////// CUSTOMER //////////////////////////

      if (this.type == 'customer') {
        this.title = this.Cust_Sale_Invoice;
        this.back_link = '../../../customer_list';
        let customer;
        let query = "SELECT `customer_name` FROM `customer` WHERE `acct_number` = '" + this.no + "' AND `status` = '1'";
        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            customer = data.data['list'];
            this.name = customer['0']['customer_name'];
          });
        this.search();
      }

      ////////////////////////// SUPPLIER //////////////////////////

      else if (this.type == 'supplier') {
        this.title = this.Supp_Purc_Invoice;
        this.back_link = '../../../supplier_list';
        let supplier;
        let query = "SELECT `supplier_name` FROM `supplier` WHERE `acct_number` = '" + this.no + "' AND `status` = '1'";
        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            supplier = data.data['list'];
            this.name = supplier['0']['supplier_name'];
          });
        this.search();
      }
      this.model['title'] = this.title;
    });
  }

  search() {
    let condition = "";

    if (this.model['from_date'] != undefined) {
      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + ' 00:00:00';;
      condition += " AND `invoice_date` >= '" + from_date + "'";
    }

    if (this.model['to_date'] != undefined) {
      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + ' 23:59:59';
      condition += " AND `invoice_date` <= '" + to_date + "'";
    }

    ////////////////////////// CUSTOMER //////////////////////////

    if (this.type == 'customer') {
      let query = "SELECT `invoice`.*, (`invoice`.`total` + `invoice`.`tax` - `invoice`.`discount`)" +
        " AS 'final_total', (CASE WHEN (`invoice`.`tax_acct` = '' OR `invoice`.`tax_acct` = '0') THEN '' ELSE " +
        "(SELECT `tax`.`tax_name_ar` FROM `tax` WHERE `tax`.`status` = '1' AND `tax`.`acct_number` = " +
        "`invoice`.`tax_acct`) END) AS 'tax_name' FROM `invoice` WHERE `invoice`.`customer_no` = '" +
        this.no + "' AND `invoice`.`status` = '1'" + condition;
      console.log(query);
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];

          this.dp.forEach(element => {
            if (element.payment_method == 'cash')
              element.payment_method = this.Cust_Sale_Invoice;
            else if (element.payment_method == 'credit')
              element.payment_method = this.credit;
            else if (element.payment_method == 'visa')
              element.payment_method = this.Visa;
            else if (element.payment_method == 'bank')
              element.payment_method = this.Bank;

            element.invoice_date = (element.invoice_date).substring(0, 10);
          });

          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        });
    }

    ////////////////////////// SUPPLIER //////////////////////////

    else if (this.type == 'supplier') {
      let query = "SELECT `supplier_invoice`.*, (`supplier_invoice`.`amount` + `supplier_invoice`.`tax` - `supplier_invoice`.`discount`)" +
        " AS 'final_total', (CASE WHEN (`supplier_invoice`.`tax_acct` = '' OR `supplier_invoice`.`tax_acct` = '0') THEN '' ELSE " +
        "(SELECT `tax`.`tax_name_ar` FROM `tax` WHERE `tax`.`status` = '1' AND `tax`.`acct_number` = " +
        "`supplier_invoice`.`tax_acct`) END) AS 'tax_name' FROM `supplier_invoice` WHERE `supplier_invoice`.`supplier_no` = '" +
        this.no + "' AND `supplier_invoice`.`status` = '1'" + condition;
      //console.log(query);
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];

          this.dp.forEach(element => {
            element.invoice_date = (element.invoice_date).substring(0, 10);

            if (element.payment_method == 'cash')
              element.payment_method = this.Cash;
            else if (element.payment_method == 'credit')
              element.payment_method = this.credit;
            else if (element.payment_method == 'visa')
              element.payment_method = this.Visa;
            else if (element.payment_method == 'bank')
              element.payment_method = this.Bank;

            element.invoice_date = (element.invoice_date).substring(0, 10);
          });

          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        });
    }
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.title + ' </td></tr>';
    html_data += '<tr><td width="50%"> : ' + this.name + '</td><td width="50%"> ' + this.Number + ': ' + this.no + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }
}
